import { memo } from 'react';

import { LazyCigarette } from './LazyCigarette';

export default memo(LazyCigarette);
